import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateCheckbookUsersFirstAndLastNamesRequestSchema,
  TUpdateCheckbookUsersFirstAndLastNamesResponseSchema,
} from "./updateCheckbookUsersFirstAndLastNames.schema";

export const updateCheckbookUsersFirstAndLastNames = (
  axios: IAxiosInstance
) => {
  return async (body: TUpdateCheckbookUsersFirstAndLastNamesRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TUpdateCheckbookUsersFirstAndLastNamesResponseSchema>
    >(`/api/update-checkbook-users-first-and-last-names`, body);

    return response.data;
  };
};
